import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext, Fragment } from 'react';
import axios from "./services/axios";
import { setFetchInstance } from "./services/sFetch";
const t = locales => {
  return function (literal, params, cb) {
    var _params;
    if (params === void 0) {
      params = [];
    }
    let result = literal;
    if (locales && Object.prototype.hasOwnProperty.call(locales, literal)) {
      var _locales$literal;
      result = (locales === null || locales === void 0 ? void 0 : (_locales$literal = locales[literal]) === null || _locales$literal === void 0 ? void 0 : _locales$literal.split('\\n').join('\n')) || locales[literal];
    }
    if (locales && literal && !Object.prototype.hasOwnProperty.call(locales, literal) && !((_params = params) !== null && _params !== void 0 && _params.length)) {
      return literal;
    }
    if (params && params.length > 0 && result) {
      result = result.replace(/%([0-9]+)\$s/g, '%@');
      if (result.includes('%@')) {
        if (cb) {
          const appearances = result.match(new RegExp('%@', 'g'));
          let lastIndex = 0;
          let resultParts = [];
          appearances.forEach((app, index) => {
            const currentIndex = result.indexOf('%@', lastIndex);
            resultParts.push(result.slice(lastIndex, currentIndex));
            resultParts.push(cb ? cb(params[index], index) : params[index]);
            lastIndex = currentIndex + 2;
          });
          if (lastIndex < result.length) {
            resultParts.push(result.slice(lastIndex, result.length));
          }
          return /*#__PURE__*/React.createElement(Fragment, null, resultParts.map((part, index) => /*#__PURE__*/React.createElement(Fragment, {
            key: index
          }, part)));
        } else {
          const appearances = result.match(new RegExp('%@', 'g')).length;
          for (let i = 0; i < appearances && i < params.length; i += 1) {
            result = result.replace('%@', params[i]);
          }
        }
      }
    }
    return result;
  };
};
export const defaultContext = {};
const Web5Context = /*#__PURE__*/React.createContext(defaultContext);
export function getContext(context) {
  let finalContext = _objectSpread(_objectSpread({}, defaultContext), context);
  if (finalContext.axiosInstance) axios.setInstance(finalContext.axiosInstance);else if (finalContext.token) axios.setData(finalContext.token, finalContext.apiBaseURL);
  if (finalContext.b2URL) axios.b2URL = finalContext.b2URL;
  if (finalContext.forceBIURL) axios.forceBIURL = finalContext.forceBIURL;
  if (finalContext.fetchInstance) {
    setFetchInstance(finalContext.fetchInstance);
  }
  finalContext.getToken = () => {
    window.sessionStorage.getItem('fm_token');
  };
  finalContext.t = t(finalContext.locales);
  return finalContext;
}
export function useWeb5Context(_temp) {
  let {
    overrides = {}
  } = _temp === void 0 ? {} : _temp;
  return _objectSpread(_objectSpread({}, useContext(Web5Context)), overrides);
}
export default Web5Context;